import { render, staticRenderFns } from "./print_tasting_tables_view.vue?vue&type=template&id=4b4e886c&scoped=true"
import script from "./print_tasting_tables_view.vue?vue&type=script&lang=js"
export * from "./print_tasting_tables_view.vue?vue&type=script&lang=js"
import style0 from "./print_tasting_tables_view.vue?vue&type=style&index=0&id=4b4e886c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e886c",
  null
  
)

export default component.exports